import React, {Component} from 'react'
import {withRouter} from 'react-router-dom'
import {withStyles} from '@material-ui/core/styles/index'
import {Card, CardContent, Button, SnackbarContent} from '@material-ui/core'
import classNames from 'classnames'
import {FuseAnimate} from '@fuse'
import {graphql} from 'react-apollo'
import qs from 'qs'

import {USER} from '../../../graphql/query'
import {VERIFY_EMAIL} from '../../../graphql/mutation'
import AuthLoadingScreen from '../../../auth/AuthLoadingScreen'

const styles = _theme => ({
  root: {
    background:
      "url('/assets/images/backgrounds/dark-material-bg.jpg') no-repeat",
    backgroundSize: 'cover',
  },
  card: {
    width: '100%',
    maxWidth: 384,
  },
})

class EmailVerificationPage extends Component {
  state = {
    verified: false,
  }

  componentDidMount() {
    const {token} = qs.parse(this.props.location.search.replace('?', ''))
    this.props
      .mutate({variables: {token}, refetchQueries: [{query: USER}]})
      .then(re => {
        this.setState({verified: true})
      })
      .catch(e => {
        this.backToLoginPage()
      })
  }

  backToLoginPage = () => {
    this.props.history.replace('/login')
  }

  render() {
    const {classes} = this.props
    return !this.state.verified ? (
      <AuthLoadingScreen />
    ) : (
      <div
        className={classNames(
          classes.root,
          'flex flex-col flex-auto flex-no-shrink items-center justify-center p-32',
        )}
      >
        <div className="flex flex-col items-center justify-center w-full">
          <FuseAnimate animation="transition.expandIn">
            <Card className={classes.card}>
              <CardContent className="flex flex-col items-center justify-center p-32">
                {this.state.resent && (
                  <SnackbarContent
                    aria-describedby="client-snackbar"
                    message="Verify link has been sent. Please check the email and follow the instruction"
                  />
                )}
                <div style={{margin: '12px', textAlign: 'center'}}>
                  <div className="mb-4 font-bold">
                    Your email have been verified
                  </div>
                  <div>You can now sign in with your new account.</div>
                </div>
                <div
                  style={{
                    display: 'flex',
                    width: '100%',
                    justifyContent: 'center',
                  }}
                >
                  <Button
                    variant="contained"
                    color="secondary"
                    onClick={this.backToLoginPage}
                  >
                    Login to Deeple
                  </Button>
                </div>
              </CardContent>
            </Card>
          </FuseAnimate>
        </div>
      </div>
    )
  }
}

export default withStyles(styles, {withTheme: true})(
  withRouter(graphql(VERIFY_EMAIL)(EmailVerificationPage)),
)



// WEBPACK FOOTER //
// ./src/main/content/login/EmailVerificationPage.js